import { render, staticRenderFns } from "./PersonalPropertiesDetailModal.vue?vue&type=template&id=42d21b4d"
import script from "./PersonalPropertiesDetailModal.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertiesDetailModal.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertiesDetailModal.vue?vue&type=style&index=0&id=42d21b4d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports